import React from 'react';
import { Phone, Wrench, CheckCircle, Award, Zap } from 'lucide-react';
export function DieselEngineRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4553">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4554">
        <div className="container mx-auto px-4" data-id="element-4555">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-4556">
            Diesel Engine Repair
          </h1>
          <p className="text-xl text-gray-100 text-center italic" data-id="element-4557">
            Serving Farmington Hills, Farmington, Novi, Livonia, Northville
            Since 1958
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4558">
        <div className="max-w-4xl mx-auto" data-id="element-4559">
          {/* Genuine Parts */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4560">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-4561">
              We Use Genuine Ford Powerstroke and Chevy Duramax Parts
            </h2>
            <p className="text-gray-700 text-center" data-id="element-4562">
              whenever possible and when a better compatible part isn't
              available at a fair price.
            </p>
          </div>

          {/* Services Overview */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4563">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-4564">
              <div data-id="element-4565">
                <ul className="space-y-3" data-id="element-4566">
                  <li className="flex items-start" data-id="element-4567">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4568" />
                    <span className="text-gray-700" data-id="element-4569">
                      <strong data-id="element-4570">
                        Major and Minor Diesel Engine Repairs on all Makes and
                        Models
                      </strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4571">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4572" />
                    <span className="text-gray-700" data-id="element-4573">
                      <strong data-id="element-4574">Diesel Engine Overhauls</strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4575">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4576" />
                    <span className="text-gray-700" data-id="element-4577">
                      <strong data-id="element-4578">Tune-ups for Diesel Engines</strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4579">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4580" />
                    <span className="text-gray-700" data-id="element-4581">
                      <strong data-id="element-4582">State-of-The-Art Computer Diagnostics</strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4583">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4584" />
                    <span className="text-gray-700" data-id="element-4585">
                      <strong data-id="element-4586">Air Systems and Fuel Systems</strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4587">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4588" />
                    <span className="text-gray-700" data-id="element-4589">
                      <strong data-id="element-4590">Preventive Maintenance Services</strong>
                    </span>
                  </li>
                </ul>
              </div>
              <div className="flex justify-center items-center" data-id="element-4591">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/jrbus%202.JPG300x300.jpg?opt=w3" alt="Diesel engine repair" className="max-w-[300px] h-auto rounded-lg shadow-md" data-id="element-4592" />
              </div>
            </div>
          </div>

          {/* Ford Powerstroke Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4593">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-4594">
              Ford Powerstroke Diesel Engine Repair
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-4595">
              We're Ford Diesel Engine Experts: Our Licensed and Certified
              Diesel Engine Mechanics provide all aspects of Powerstroke Diesel
              Engine Diagnostics, Maintenance and Repair. Having decades of
              experience in diesel engine repair applied to every job saves you
              time, money, and in many cases, a severe headache. The Ford
              Powerstroke Engine line is a powerful horsepower plant, capable of
              reliably hauling heavy loads for hundreds of thousands of miles.
              Keeping these diesel engines operating properly is imperative to
              your bottom line.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-4596">
              <p className="text-gray-800 font-bold text-center text-lg" data-id="element-4597">
                We Sell and Use Only Genuine Ford Powerstroke Parts or Parts
                Compatible with Ford Powerstroke Engines.
              </p>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-4598">
              Our Licensed and Certified Diesel Engine Mechanics Perform All
              Aspects of Service on Ford Powerstroke Diesel Engines:
            </h3>

            <ul className="space-y-3 mb-6" data-id="element-4599">
              <li className="flex items-start" data-id="element-4600">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4601" />
                <span className="text-gray-700" data-id="element-4602">
                  Routine Maintenance and Preventive Service
                </span>
              </li>
              <li className="flex items-start" data-id="element-4603">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4604" />
                <span className="text-gray-700" data-id="element-4605">
                  Ford Powerstroke Diesel Engine Diagnostics
                </span>
              </li>
              <li className="flex items-start" data-id="element-4606">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4607" />
                <span className="text-gray-700" data-id="element-4608">
                  Ford Powerstroke Diesel Engine Fuel System Diagnostics and
                  Repairs
                </span>
              </li>
              <li className="flex items-start" data-id="element-4609">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4610" />
                <span className="text-gray-700" data-id="element-4611">
                  Powerstroke Diesel Engine Injector Diagnostics and Injector
                  Replacement
                </span>
              </li>
              <li className="flex items-start" data-id="element-4612">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4613" />
                <span className="text-gray-700" data-id="element-4614">
                  DEF System Diagnostics, Maintenance and Repairs
                </span>
              </li>
              <li className="flex items-start" data-id="element-4615">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4616" />
                <span className="text-gray-700" data-id="element-4617">
                  Powerstroke Diesel Engine Oil Change
                </span>
              </li>
              <li className="flex items-start" data-id="element-4618">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4619" />
                <span className="text-gray-700" data-id="element-4620">
                  Powerstroke Diesel Engine Filter Changes
                </span>
              </li>
            </ul>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6" data-id="element-4621">
              <p className="text-gray-700" data-id="element-4622">
                Ford Diesel Fuel Injectors will begin needing replacement often
                at around 120,000 miles. Due to the poor fuel that is common
                today, its super low sulfur content reduces lubrication and
                increases wear and tear on these injectors. The Ford replacement
                injectors are okay, but there are better injectors available
                which we normally use when installing new diesel fuel injectors
                into a Ford Powerstroke Diesel Engine. This has a little
                increase in expense, but they last much longer, are more
                reliable and make your diesel engine more efficient - that saves
                you more than the slight increase in installing the better
                diesel fuel injectors.
              </p>
            </div>
          </div>

          {/* Chevy Duramax Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4623">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-4624">
              Chevy Duramax Diesel Engine Repair
            </h2>

            <p className="text-center text-lg font-semibold text-gray-800 mb-4" data-id="element-4625">
              Our Service uses Genuine Chevy Duramax Diesel Parts where possible
              and when better compatible parts are not available.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-4626">
              Duramax Diesel Engine Repairs Performed By Licensed and Certified
              Diesel Engine Mechanics
            </h3>

            <p className="text-gray-700 mb-6" data-id="element-4627">
              Duramax Diesel Engines are reliable and powerful, but just like
              all engines they need proper maintenance and repairs or severe
              damage may occur.
            </p>

            <p className="text-gray-700 mb-6" data-id="element-4628">
              Our licensed and certified diesel mechanics are experienced with
              Chevy Duramax Diesel Engines. Whether you need routine
              maintenance, such as oil and filter changes or glow plug
              replacement, fuel injector replacement, or a complete Duramax
              Engine Rebuild, we are your Diesel Engine Mechanic Shop.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-4629">
              Duramax Diesel Engines We Work On:
            </h3>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-4630">
              <ul className="space-y-2 text-gray-700" data-id="element-4631">
                <li className="text-center" data-id="element-4632">
                  Duramax LB7 (2001-2004 Chevrolet Silverado HD and GMC Sierra
                  HD)
                </li>
                <li className="text-center" data-id="element-4633">Duramax LLY (2004.5-2005)</li>
                <li className="text-center" data-id="element-4634">Duramax LBZ (2006-2007)</li>
                <li className="text-center" data-id="element-4635">Duramax LMM (2008-2010)</li>
                <li className="text-center" data-id="element-4636">Duramax LML (2011-2016)</li>
                <li className="text-center" data-id="element-4637">
                  Duramax LGH (2011-2016 Chevrolet Express and GMC Savana)
                </li>
                <li className="text-center" data-id="element-4638">Duramax L5P (2017-)</li>
              </ul>
            </div>
          </div>

          {/* 7.3L Powerstroke History */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4639">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-4640">
              History of the 7.3 liter International Engine
            </h2>

            <div className="flex justify-center mb-6" data-id="element-4641">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/7.3%20ps.jpg200x200.jpg?opt=w3" alt="7.3 Powerstroke engine" className="max-w-[305px] h-auto rounded-lg shadow-md" data-id="element-4642" />
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4643">
              7.3 Powerstroke
            </h3>

            <div className="space-y-4 text-gray-700" data-id="element-4644">
              <p data-id="element-4645">
                The first 7.3L was produced from 1988-1993. The original 7.3L
                diesel was a non-turbo charged indirect injection (IDI) engine,
                followed shortly after by a turbo charged version. It was very
                similar to the previous 6.9l IDI diesel engine, which was simply
                bored out for more torque. This engine is not considered in the
                powerstroke family. In 1994, the 7.3L underwent some changes.
                The 7.3L was changed to a direct injection (DI) engine from the
                original IDI engine.
              </p>

              <p data-id="element-4646">
                Ford also added electronic fuel injectors and gave it the name
                Power Stroke. This model produced up to 250 hp (190 kW) and 525
                lb·ft (712 N·m) of torque. The new 7.3L DI Power stroke had
                "single shot" HEUI (hydraulic electronic unit injectors) fuel
                injectors and ran a 15º high pressure oil pump (HPOP) to create
                fuel injection pressures. The turbine housing was a 1.15 A/R. In
                1999, an air to air intercooler was added. The intercooler
                cooled the charged air from the turbo making it denser. The
                cooler, denser air would increase the horsepower potential of
                the engine, while also reducing exhaust gas temperatures (EGTs).
                The turbine housing was changed to a .84 A/R housing and a
                wastegate was added.
              </p>

              <p data-id="element-4647">
                The "single shot" HEUI injectors were upgraded to "split shot"
                injectors. With larger injectors, the HPOP was advanced to 17º
                to increase fuel pressures. The 7.3L DI Power Stroke was in
                production up until 2004 when it was replaced by the 6.0L. The
                7.3 IDI and 7.3 Powerstroke are not the same engine at all
                except manufactured by International for Ford. This is known to
                be the longest lasting and most reliable powerstroke engine.
              </p>
            </div>

            <div className="bg-red-50 border-2 border-[#B1050B] rounded-lg p-6 mt-6 text-center" data-id="element-4648">
              <p className="text-2xl font-bold text-[#B1050B]" data-id="element-4649">
                We Are Powerstroke Experts
              </p>
            </div>
          </div>

          {/* Second Generation Powerstroke */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4650">
            <div className="flex justify-center mb-6" data-id="element-4651">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/0810dp_05_z+ford_power_stroke_diesel+second_generation_power_stroke.jpg300x300.jpg?opt=w3" alt="Second generation Powerstroke" className="max-w-[300px] h-auto rounded-lg shadow-md" data-id="element-4652" />
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4653">
              Hydraulically Actuated Electronically Controlled Unit Injector
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-4654">
              The new HEUI Fuel systems on the Power Stroke required the use of
              two oil pumps. A low-pressure (lubricating) pump feeds oil into
              the high-pressure oil reservoir, where the high-pressure oil pump
              (HPOP) forces oil through oil lines to two high-pressure oil
              rails, one located in each cylinder head at an injection oil
              pressure of 500-3,000 psi. The pressure is controlled
              electronically by a regulator located inside the pump. Basically,
              all of this culminates in a unique system where the oil increases
              the fuel pressure at the injectors.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4655">
              Second-Generation Power Stroke
            </h3>
            <p className="text-gray-700" data-id="element-4656">
              The second generation of 7.3L began with the '99 model year. This
              version of the Power Stroke was intercooled (termed charge air
              cooling or CAC), fittingly for trucks labeled "Super Duty," and
              put out more horsepower and torque. First-year Super Dutys and '00
              engines put out 235 hp and 500 lb-ft of torque. Although '99 and
              '00 models shared the same engine, '99s can be spotted by their
              "Power Stroke V-8" badge that is visible in front of the truck's
              front fender-wells. Power Stroke badges built in 2000 or later are
              displayed on the bottom of each truck's door panels.
            </p>
          </div>

          {/* Generation Link */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8 text-center" data-id="element-4657">
            <p className="text-[#B1050B] font-bold mb-4" data-id="element-4658">
              What Generation Engine is in my Truck? Click below to find out
            </p>
            <a href="/services/ford-7-3l-gas" className="inline-block bg-[#B1050B] hover:bg-[#8A0408] text-white px-6 py-3 rounded-lg font-bold text-lg transition-colors" data-id="element-4659">
              7.3l Power Stroke 1st Generation or Second Generation
            </a>
          </div>

          {/* How Diesel Engines Work */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4660">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-4661">
              How diesel engines work
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-4662">
              When gas is compressed its temperature rises. A diesel engine
              exploits this property in order to ignite the fuel. Air is drawn
              into the cylinder of a diesel engine, and compressed by the rising
              piston. This happens at a much higher compression rate than in a
              spark-ignition engine. At the top of the piston stroke diesel fuel
              is injected into the combustion chamber at high pressure through
              an atomising nozzle. It mixes with the hot, pressurised air. The
              resulting mixture ignites and burns very rapidly. This contained
              explosion causes the gas in the chamber to expand, driving the
              piston down with considerable force, and creating power in a
              vertical direction.
            </p>

            <div className="space-y-4" data-id="element-4663">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-4664">
                <p className="text-gray-700" data-id="element-4665">
                  A gasoline engine intakes a mixture of gas and air, compresses
                  it and ignites the mixture with a spark. A diesel engine takes
                  in just air, compresses it and then injects fuel into the
                  compressed air. The heat of the compressed air lights the fuel
                  spontaneously.
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-4666">
                <p className="text-gray-700" data-id="element-4667">
                  A gasoline engine compresses at a ratio of 8:1 to 12:1, while
                  a diesel engine compresses at a ratio of 14:1 to as high as
                  25:1. The higher compression ratio of the diesel engine leads
                  to better efficiency.
                </p>
              </div>
            </div>
          </div>

          {/* Fuel Delivery Systems */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4668">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-4669">
              Fuel Delivery Systems
            </h3>

            <p className="text-gray-700 mb-4" data-id="element-4670">
              Gasoline engines use either a carburetor or a fuel injection
              system to deliver the fuel to the cylinder. With a carburetor the
              fuel is mixed as it enters the intake manifold, long before it
              gets to the cylinders. In a fuel injection system the fuel is
              injected just before the intake stroke at the intake valve.
            </p>

            <p className="text-gray-700" data-id="element-4671">
              Diesel engines use direct fuel injection (DI), that is to say the
              diesel fuel is injected directly into the cylinder. The diesel
              engine has no spark plugs. The air it takes in is compressed and
              the fuel is injected directly into the cylinder where the heat
              caused by the air compression ignites the fuel. In the old days
              this meant that it exploded and expanded very quickly, making a
              noisy engine. This is why most diesel cars were IDI (indirect
              injection); the rough behavior was fixed by injecting the fuel
              into a small pre-combustion chamber that is connected to the
              cylinder by a narrow passage.
            </p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4672">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4673">
              Need Diesel Engine Service?
            </h2>
            <p className="text-xl mb-6" data-id="element-4674">
              <strong data-id="element-4675">If We can Help Give us a Call</strong>
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4676">
              <Phone className="mr-3" size={24} data-id="element-4677" />
              Call 248-478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4678">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}